module.exports = __webpack_public_path__ + "img/pnu_read_detail.673d9ca6.jpg";